import { Control } from 'react-hook-form';
import { Typography } from '@weareopenr/component-library';
import { FormAutocomplete } from 'src/components/FormElements';
import { IMenu } from 'src/types/menu.types';
import { IPriceScheme } from 'src/types/price.types';
import { ICreateTimetableFormValues } from '../types';
import styles from './TimetableDefaultsFields.module.scss';

interface TimetableDefaultsFieldsProps {
  control: Control<ICreateTimetableFormValues>;
  menus: IMenu[];
  isMenusLoading: boolean;
  priceSchemes: IPriceScheme[];
  isPriceSchemesLoading: boolean;
}

export const TimetableDefaultsFields = ({
  control,
  menus,
  isMenusLoading,
  priceSchemes,
  isPriceSchemesLoading,
}: TimetableDefaultsFieldsProps) => {
  const menuOptions = menus.map((menu) => ({ id: menu.menuId, name: menu.name }));
  const priceSchemeOptions = priceSchemes.map((scheme) => ({ id: scheme.id, name: scheme.name }));

  return (
    <div className={styles['defaults-section']}>
      <div className={styles['defaults-section-sub']}>
        <Typography size="medium" weight="bold">
          Define the Defaults:
        </Typography>
        <Typography size="xsmall">
          Default Menus and Price schemes will cover the full weekly timetable, allowing you to quickly build on top.
        </Typography>
      </div>

      <FormAutocomplete
        name="defaultMenuId"
        control={control}
        label="Default Menu"
        options={menuOptions}
        disabled={isMenusLoading}
        rules={{ required: 'Please select a default menu' }}
        className={styles['default-menu-field']}
      />

      <FormAutocomplete
        name="defaultPriceSchemeId"
        control={control}
        label="Default Price Scheme"
        options={priceSchemeOptions}
        disabled={isPriceSchemesLoading}
        rules={{ required: 'Please select a default price scheme' }}
        forceBottomPlacement
      />
    </div>
  );
};

export default TimetableDefaultsFields;
